export default "__VITE_PUBLIC_ASSET__9eb6ca6b__"